import React from "react";
import { SimpleShowLayout, TextField } from "react-admin";

const Tab = (props) => {
  return (
    <SimpleShowLayout record={props.record[props.side]}>
      <TextField source="season.team.name" />
      <TextField source="id" />
      <TextField source="baseball.id" />
      <TextField source="baseball.runs" />
      <TextField source="baseball.hits" />
      <TextField source="baseball.errors" />
    </SimpleShowLayout>
  );
};

export default Tab;
